export default __webpack_public_path__ + "3a7c69d74226a841117c03ce23521efe.png";